import { render, staticRenderFns } from "./NewsProgramList.vue?vue&type=template&id=286c65d1&"
import script from "./NewsProgramList.vue?vue&type=script&lang=js&"
export * from "./NewsProgramList.vue?vue&type=script&lang=js&"
import style0 from "./NewsProgramList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports